import { Button, Dialog, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from 'react';
import { TrackerDataType } from '../../shared/constants/constants';
import { Link } from 'react-router-dom';
import { getForwardingAddress } from '../AutoTrackerPage/emailScrapingRequests';

interface AddAutomaticallyButtonProps {
  eventHandler: any;
}
const AddAutomaticallyButton = (props: AddAutomaticallyButtonProps) => {
  const { eventHandler } = props;
  const [openModal, setOpenModal] = useState(false);
  const [forwardingAddress, setForwardingAddress] = useState('');

  const handleClose = () => {
    setOpenModal(false);
  };

  useEffect(() => {
    getForwardingAddress().then((response) => {
      setForwardingAddress(response);
    });
  }, []);

  let componentColor: 'mediaInteraction' | 'primary' | 'primaryLighter';
  let entryName: 'Service' | 'Media Interaction' | 'Engagement';
  let emailName: string;
  switch (eventHandler.type) {
    case TrackerDataType.MEDIA_INTERACTION:
      componentColor = 'mediaInteraction';
      entryName = 'Media Interaction';
      emailName = forwardingAddress || '';
      break;
    case TrackerDataType.SERVICE:
      componentColor = 'primary';
      entryName = 'Service';
      emailName = forwardingAddress ? forwardingAddress.replace('interaction', 'service') : '';
      break;
    case TrackerDataType.ENGAGEMENT:
      componentColor = 'primaryLighter';
      entryName = 'Engagement';
      emailName = forwardingAddress ? forwardingAddress.replace('interaction', 'engagement') : '';
      break;
    default:
      componentColor = 'primary';
      entryName = 'Service';
      emailName = forwardingAddress ? forwardingAddress.replace('interaction', 'service') : '';
      break;
  }

  return (
    <>
      <Button
        variant="contained"
        color={componentColor}
        sx={{ height: '32px' }}
        startIcon={<AddIcon />}
        onClick={() => setOpenModal(true)}
        data-cy="addAutomatically"
      >
        <Typography>AutoTracker</Typography>
      </Button>
      <Dialog
        open={openModal}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogTitle style={{ paddingLeft: 0, paddingTop: 0 }}>
            Let AutoTracker make a {entryName} for you!
          </DialogTitle>
          <DialogContentText>
            Send a relevant email to <Link to={`mailto:${emailName}`}>{emailName}</Link>, and in around 30 seconds,
            AutoTracker will prepare a {entryName} for you to add!
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AddAutomaticallyButton;
